<template>
  <div class="homepage">
    <div class="topText">
      <generic-big-text
        :text="topText.text"
        :btn-text="topText.btnText"
        :btn-href="topText.btnHref"
        :btn-style="topText.btnStyle"
        :bg-style="topText.bgStyle"
        :text-color="topText.textColor"></generic-big-text>
    </div>


    <div class="mb-80" v-if="!!bigCall">
      <div class="container">
        <div class="bigCall imageWidgetWrapper">
          <image-widget
            :key="bigCall.id"
            :title="bigCall.title"
            :sub-title="bigCall.subTitle"
            :img="bigCall.img"
            :cta-href="bigCall.ctaHref"
            :cta-text="bigCall.ctaText"
            :data-target="bigCall.dataTarget"></image-widget>
        </div>
      </div>
    </div>

    <div class="mb-80 crowdfundingProjectWidgetsWrapper" v-if="!!crowdfundingProjectWidgets.length">
      <div class="container">
        <h3 class="sectionsTitle" v-html="crowdfundingProjectWidgetsTitle"></h3>
      </div>
      <div class="crowdfundingProjectWidgets">
        <gallery
          :conf="{
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            setGallerySize: false,
            watchCss: true,
            wrapAround: crowdfundingProjectWidgets.length > 3 ? true : false,
            cellAlign: 'left'
          }"
          :prev-style="{
            display: crowdfundingProjectWidgets.length > 1 ? 'block' : 'none',
          }"
          :next-style="{
            display: crowdfundingProjectWidgets.length > 1 ? 'block' : 'none',
          }">
          <div class="carousel-cell" v-for="item in crowdfundingProjectWidgets">
            <crowdfunding-project-widget
              :key="item.id"
              :title="item.title"
              :content="item.content"
              :place="item.place"
              :label="item.label"
              :link="item.link"
              :image="item.image"></crowdfunding-project-widget>
          </div>
        </gallery>
      </div>
    </div>


    <div class="mb-80 pb-45 pt-45 background-color-lightgrey imageWidgetWrapper imageWidgetsWrapper" v-if="!!imagesWidget.length">
      <div class="container">
        <h3 class="sectionsTitle" v-html="imageWidgetsTitle"></h3>
      </div>
      <gallery
        :conf="{
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          wrapAround: imagesWidget.length > 2 ? true : false,
          cellAlign: 'left'
        }"
        :prev-style="{
          display: imagesWidget.length > 2 ? 'block' : 'none',
        }"
        :next-style="{
          display: imagesWidget.length > 2 ? 'block' : 'none',
        }">
        <div class="carousel-cell" v-for="image in imagesWidget">
          <image-widget
            :key="image.id"
            :title="image.title"
            :sub-title="image.subTitle"
            :img="image.img"
            :cta-href="image.ctaHref"
            :cta-text="image.ctaText"
            :content="image.content"
            :data-target="image.dataTarget"></image-widget>
        </div>
      </gallery>
    </div>



    <div class="mb-80 sectionsWrapper">
      <div class="container">
        <h3 class="sectionsTitle" v-html="sectionsTitle"></h3>
        <div class="sections">
          <network-section
            v-for="section in sections"
            :id="section.id"
            :color="section.color"
            :title="section.title"
            :text="section.text"
            :key="section.id"></network-section>
        </div>
      </div>
    </div>

    <div class="mb-80 bigBtnWrapper">
      <big-btn
        :color="bigBtn.color"
        :btn-href="bigBtn.btnHref"
        :btn-text="bigBtn.btnText"></big-btn>
    </div>


    <div class="mb-80 pt-40 pb-80 supportersWrapper background-color-lightgrey" v-if="!!supporters.length">
      <div class="container">
        <div class="d-md-flex">
          <h3 class="sectionsTitle" v-html="supportersTitle"></h3>
          <a
            class="supporterLink"
            href="#"
            @click.prevent="onSupportersLinkClick">
            Vuoi diventare Partner? Scrivici
          </a>
        </div>

        <div class="supporters">
          <supporter-widget
              v-for="supporter in supporters"
              class="mb-40"
              :id="supporter.id"
              :image="supporter.image"
              :title="supporter.title"
              :content="supporter.content"
              :cta-href="supporter.ctaHref"
              :cta-text="supporter.ctaText"
              :key="supporter.id" />
        </div>
      </div>
    </div>

    <div class="mb-80 storiesWrapper" v-if="!!stories.length">
      <div class="container">
        <h3 class="sectionsTitle" v-html="storiesTitle"></h3>
      </div>
      <div class="stories">
        <gallery
          :conf="{
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            setGallerySize: false,
            watchCss: true,
            wrapAround: stories.length > 3 ? true : false,
            cellAlign: 'left'
          }"
          :prev-style="{
            display: stories.length > 3 ? 'block' : 'none',
          }"
          :next-style="{
            display: stories.length > 3 ? 'block' : 'none',
          }">
          <div class="carousel-cell" v-for="story in stories">
            <story-widget
              :key="story.id"
              :title="story.title"
              :story-href="story.storyHref"
              :img="story.img"
              :authors="story.authors"></story-widget>
          </div>
        </gallery>
      </div>
    </div>

    <div class="footerCarouselWidgets mb-80" v-if="!!footerCarouselWidgets.length">
      <div class="footerCarousel">
        <gallery
          :conf="{
            prevNextButtons: false,
            pageDots: false,
            wrapAround: footerCarouselWidgets.length > 2 ? true : false,
            cellAlign: 'left'
          }"
          :prev-style="{
            display: footerCarouselWidgets.length > 1 ? 'block' : 'none',
          }"
          :next-style="{
            display: footerCarouselWidgets.length > 1 ? 'block' : 'none',
          }">
          <div class="carousel-cell" v-for="w in footerCarouselWidgets">
            <generic-big-text
              :text="w.text"
              :btn-text="w.btnText"
              :btn-href="w.btnHref"
              :btn-style="w.btnStyle"
              :bg-style="w.bgStyle"
              :text-color="w.textColor"></generic-big-text>
          </div>
        </gallery>
      </div>
    </div>

    <!--

    <generic-big-text
      :text="bottomText.text"
      :btn-text="bottomText.btnText"
      :btn-href="bottomText.btnHref"
      :btn-style="bottomText.btnStyle"
      :bg-style="bottomText.bgStyle"
      :text-color="bottomText.textColor"></generic-big-text>

    -->

    <div class="bottomTextWrapper mb-80">
      <div class="container">
        <network-description
          :network-logo="networkDescription.networkLogo"
          :network-name="networkDescription.networkName"
          :btn-href="networkDescription.btnHref"
          :btn-text="networkDescription.btnText"
          :text="networkDescription.text"></network-description>
      </div>
    </div>
  </div>
</template>

<script>

  import EventBus from '../views/event_bus';

  import GenericBigText from './generic_big_text'
  import ImageWidget from './image_widget'
  import NetworkSection from './network_section'
  import BigBtn from './big_btn'
  import StoryWidget from './story_widget'
  import NetworkDescription from './network_description'
  import CrowdfundingProjectWidget from './crowdfunding_project_widget'
  import SupporterWidget from './supporter_widget'
  import Gallery from './gallery'

  export default {
    name: 'Homepage',
    components:{
      GenericBigText,
      ImageWidget,
      NetworkSection,
      BigBtn,
      StoryWidget,
      CrowdfundingProjectWidget,
      NetworkDescription,
      SupporterWidget,
      Gallery
    },

    data(){
      return {
      }
    },
    props: {
      stories: {
        type: Array,
        default: ()=>{}
      },
      bigCall: {
        type: Object,
        default: ()=>{}
      },
      imagesWidget: {
        type: Array,
        default: ()=>{}
      },
      sections: {
        type: Array,
        default: ()=>{}
      },
      sectionsTitle: {
        type: String,
        default: ""
      },
      supporters: {
        type: Array,
        default: ()=>{}
      },
      supportersTitle: {
        type: String,
        default: ""
      },

      supportersModalTitle: {
        type: String,
        default: ""
      },

      supportersModalContent: {
        type: String,
        default: ""
      },

      supportersModalCtaText: {
        type: String,
        default: ""
      },

      supportersModalCtaHref: {
        type: String,
        default: ""
      },

      bigBtn: {
        type: Object,
        default: ()=>{}
      },
      storiesTitle: {
        type: String,
        default: ""
      },

      crowdfundingProjectWidgetsTitle: {
        type: String,
        default: ""
      },

      imageWidgetsTitle: {
        type: String,
        default: ""
      },

      crowdfundingProjectWidgets: {
        type: Array,
        default: ()=>{}
      },

      footerCarouselWidgets: {
        type: Array,
        default: ()=>{}
      },

      topText: {
        type: Object,
        default: ()=>{}
      },
      bottomText: {
        type: Object,
        default: ()=>{}
      },
      networkDescription: {
        type: Object,
        default: ()=>{}
      }
    },
    computed: {
    },
    mounted(){
      window.addEventListener('changeTab', function (e) {
        setTimeout(()=>{
            if (typeof (Event) === 'function') {
              // Modern browsers
              window.dispatchEvent(new Event('resize'))
            } else {
              // Old browsers (especially IE)
              let resizeEvent = window.document.createEvent('UIEvents')
              resizeEvent.initUIEvent('resize', true, false, window, 0)
              window.dispatchEvent(resizeEvent)
            }
        },100)
      });
    },
    methods: {
      onSupportersLinkClick(e){
        EventBus.$emit('content-modal', {
          title: this.supportersModalTitle,
          ctaHref: this.supportersModalCtaHref,
          ctaText: this.supportersModalCtaText,
          content: this.supportersModalContent
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';


  .supporterLink{
    &:link, &:visited, &:hover, &:active{
      text-decoration: none;
      font-size: 18px;
      line-height: 22px;
    }
  }

  /deep/ .container{
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
  }

  .bigCall{
    margin-bottom: 20px;
  }

  .flickity-slider,
  .sections{
    display: flex;
    align-items: stretch;
    position: relative;
    z-index: 1;
    @media (max-width:  @bootstrap-md - 1px){
      flex-direction: column;
    }
  }

  .stories,
  .stories /deep/ .flickity-enabled,
  .stories /deep/ .flickity-viewport,
  .stories /deep/ .flickity-slider{
    height: 520px;
  }

  .imageWidgetWrapper /deep/ .ImageWidget {
    /*
    flex: ~'1 0 calc(50% - 0px)';
    @media (min-width: @bootstrap-md){
      margin-left: 15px;
      &:first-child{
        flex: ~'1 0 calc(50%)';
        margin-left: 0;
      }
    }

    @media (max-width:  @bootstrap-md - 1px){
      margin-top: 15px;
    }

    */
    @media (min-width: @bootstrap-md){
      margin-left: 15px;
      flex: ~'0 0 calc(100% - 15px)';
      &:first-child{
        margin-left: 0;
        margin-right: 15px;
      }
    }

  }

  .sections{
    max-width: 1080px;
    margin: 0 auto;
    @media (max-width: @bootstrap-md - 1px){
      flex-direction: column;
      .imageWidgetWrapper /deep/ .ImageWidget {
        margin-left: 15px;
        margin-right: 15px;
        &:first-child{
          margin-left: 15px;
          margin-right: 15px;
        }
      }
    }
  }

  .crowdfundingProjectWidgets{
    .flickity-slider .carousel-cell{
      width: 100%;
    }
  }

  .crowdfundingProjectWidgets,
  .crowdfundingProjectWidgets /deep/ .flickity-enabled,
  .crowdfundingProjectWidgets /deep/ .flickity-viewport,
  .crowdfundingProjectWidgets /deep/ .flickity-slider{
    min-height: 300px;
    @media (min-width: @bootstrap-md){
      height: 300px;
    }
  }

  .crowdfundingProjectWidgets /deep/ .carousel-cell{
    @media (max-width: @bootstrap-md - 1px){
      width: 95%;
    }
  }

  .footerCarouselWidgets /deep/ .Gallery{
    background-color: var(--special-network-color)
  }

  .footerCarouselWidgets /deep/ .std-carousel{
    width: 100%;
    padding: 0;
    position: relative;
  }

  .footerCarouselWidgets /deep/ .carousel-cell{
    width: 95%;
    @media (min-width: @bootstrap-md){
      width: 100%;
      height: 512px;
    }
  }

  .footerCarouselWidgets /deep/ .btn{
    top: 50%;
    margin-top: -15px;
    @media (min-width: @bootstrap-md){
      &.prev{
        left: 5px;
      }
      &.next{
        transform: rotate3d(0,0,1, -180deg);
        right: 5px;
      }
    }
    @media (min-width: @bootstrap-xl){
      &.prev{
        left: -27px;
      }
      &.next{
        transform: rotate3d(0,0,1, -180deg);
        right: -27px;
      }
    }
  }

  .footerCarouselWidgets /deep/ .GenericBigText .content{
    font-weight: @bold;
  }

  .imageWidgetsWrapper /deep/ .btn,
  .stories /deep/ .btn{
    background-image: url(../../img/thick-arrow-black.svg);
  }

  .sections /deep/ .NetworkSection,
  .stories /deep/ .StoryWidget {
    @media (min-width: @bootstrap-lg){
      flex: ~'1 0 calc(33.33%)';
      margin-left: 15px;
      &:first-child{
        margin-left: 0;
      }
    }
    @media (max-width: @bootstrap-lg - 1px){
      flex-grow: 1;
      flex: ~'1 0 calc(33%)';
      margin-left: 5px;
      &:first-child{
        margin-left: 0;
      }
    }

    @media (max-width: @bootstrap-md - 1px){
      margin-top: 15px;
      margin-left: 0;
    }
  }

  .sectionsWrapper{
    position: relative;
    z-index: 1;
    &:after{
      content: '';
      z-index: 0;
      position: absolute;
      background: #fff;
      height: 155px;
      width: 100%;
      bottom: 0;
    }
  }

  .sectionsWrapper /deep/ .NetworkSection{
    /* box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.1); */
  }

  .sectionsTitle{
    font-size: 36px;
    line-height: 52px;
    margin-bottom: 60px;
    margin-top: 0;
    font-weight: 300;
    @media (max-width: @bootstrap-md - 1px){
      font-size: 22px;
      line-height: 30px;
    }
  }

  .bigBtnWrapper{
    max-width: 1254px;
    margin-left: auto;
    margin-right: auto;
    > .container{
      max-width: 1254px;
    }
  }

  .supportersWrapper{
    .d-md-flex{
      margin-bottom: 50px;
      display: flex;
      flex-direction: column;
      @media (min-width: @bootstrap-md){
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }

    .sectionsTitle{
      margin-bottom: 0;
    }
  }

  .storiesWrapper{
    margin-top: 95px;
    margin-bottom: 110px;
  }

  .stories .flickity-slider .carousel-cell{
    width: 360px;
    .StoryWidget{
      margin-right: 15px;
    }
    @media (max-width: @bootstrap-md - 1px){
      width: 95%;
      .StoryWidget {
        width: 95%;
      }
    }
  }

  .container.noFLK{
    @media (max-width: @bootstrap-md - 1px){
      .carousel-cell{
        width: 93%;
        flex: 93% 0 0;
        &:first-child{
          margin-left: 15px;
        }
        .StoryWidget {
          width: 95%;
        }
        .ImageWidget{
          width: 95%;
        }
      }
    }
  }

  .stories{
    @media screen and ( max-width: @bootstrap-md - 1px ) {
      /* disable Flickity for large devices */
      .carousel:after {
        content: '';
      }
    }
  }

  .imageWidgetWrapper .flickity-slider .carousel-cell{
    display: flex;
    width: ~'calc(50vw - 30px)';
    @media (min-width: @bootstrap-xl){
      width: 540px;
    }

    @media (max-width: @bootstrap-md - 1px){
      width: 95%;
      .ImageWidget {
        width: 95%;
        &:first-child{
        }
      }
    }
  }

  @media (min-width: @bootstrap-md){
    .topText /deep/ .bg{
        padding: 80px 0 80px !important;
    }
  }
</style>
